module.exports = __webpack_public_path__ + "img/video1.058c5d4f.png";